//陕西晟翔管道科技有限公司
const sxlb1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb1.png";
const sxlb2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb2.jpg";
const sxlb3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb3.jpg";
const sxlb4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb4.jpg";
const sxlb5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb5.jpg";
const sxlb6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb6.jpg";
const sxlb7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb7.jpg";
const sxlb8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb8.png";
const sxlb9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxlb9.png";
const sxgs1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgs1.jpg";

//产品
const sxcp1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp1.png";
const sxcp2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp2.png";
const sxcp3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp3.png";
const sxcp4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp4.png";
const sxcp5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp5.png";
const sxcp6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp6.png";
const sxcp7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp7.png";
const sxcp8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp8.png";
const sxcp9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp9.png";
const sxcp10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp10.png";
const sxcp11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp11.png";
const sxcp12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp12.png";
const sxcp13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp13.png";
const sxcp14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp14.png";
const sxcp15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp15.png";
const sxcp16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp16.png";
const sxcp17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp17.png";
const sxcp18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp18.png";
const sxcp19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp19.png";
const sxcp20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp20.png";
const sxcp21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp21.png";
const sxcp22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxcp22.png";
const sxbg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg1.png";
const sxbg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg2.png";
const sxbg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg3.png";
const sxbg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg4.png";
const sxbg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg5.png";
const sxbg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg6.png";
const sxbg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg7.png";
const sxbg8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg8.png";
const sxbg9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg9.png";
const sxbg10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg10.png";
const sxbg11 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg11.png";
const sxbg12 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg12.png";
const sxbg13 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg13.png";
const sxbg14 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg14.png";
const sxbg15 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg15.png";
const sxbg16 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg16.png";
const sxbg17 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg17.png";
const sxbg18 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg18.png";
const sxbg19 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg19.png";
const sxbg20 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg20.png";
const sxbg21 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg21.png";
const sxbg22 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg22.png";
const sxbg23 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg23.png";
const sxbg24 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg24.png";
const sxbg25 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg25.png";
const sxbg26 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg26.png";
const sxbg27 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg27.png";
const sxbg28 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg28.png";
const sxbg29 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg29.png";
const sxbg30 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg30.png";
const sxbg31 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg31.png";
const sxbg32 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg32.png";
const sxbg33 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxbg33.png";
// 工程案例
const sxcg1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc1.png";
const sxcg2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc2.png";
const sxcg3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc3.png";
const sxcg4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc4.png";
const sxcg5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc5.png";
const sxcg6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc6.png";
const sxcg7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxgc7.png";

const sxht1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht4 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht5 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht6 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht7 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht8 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht9 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const sxht10 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxht1.jpg";
const icon1 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon1.png";
const icon2 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon2.png";
const icon3 = "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/icon3.png";
export default {
    homeData: {
		herderBanner: [sxlb1, sxlb2, sxlb3, sxlb4, sxlb5, sxlb6, sxlb7, sxlb8, sxlb9],
		//企业logo
		logo: "https://omo-oss-image.thefastimg.com/portal-saas/new2022110120024566437/cms/image/fa1d9ce1-d88a-45cb-8229-1beb7724faf4.png",
		// logo: dx_logo,
		//企业Vr背景
		vRlogo: sxgs1,
		isShowVrModal: false,
		isShowVr: true,
		vRurl: "",
		isVideo: false,
		videoLogo: "",
		videoUrl: "",
		//首页banner
		bannerHeight: "300px",
		banner: [
			"https://cbu01.alicdn.com/img/ibank/O1CN01T3X6TN1vRuP2TW5Sz_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN011pHE411vRuPAvkMuF_!!2206529366170-0-cib.jpg",
			"https://cbu01.alicdn.com/img/ibank/O1CN01GTletP1vRuP4R6kYk_!!2206529366170-0-cib.jpg",
		],
		//企业介绍
		overview: `陕西晟翔管道科技有限公司位于陕西省富平县庄里工业园，是一家集管道研发、生产、销售、服务于一体的现代化高科技企业，公司采用德国挤出生产线，专业制造新型环保塑料管道，产品涵盖HDPE、PP给水管道，HDPE燃气管道、MPP电力电缆护套管、HDPE矿用管道、HDPE、PP排水排污管道等系列产品。
		公司始终以“科技创新为先，管理信誉为本”为宗旨，坚持以“质量为基础，顾客为核心，创新为灵魂”作为企业的经营理念，发扬持续改进，追求优异的敬业精神，严格规范企业的行为准则，确保公司以优异的产品服务于客户，不断完善自身，使本公司产品、服务质量和管理迈上新的台阶，为客户提供更加满意的产品和优异的服务！
		`,
		//公司官网
		website: "www.sxsxgd.com/",
		operatingStatus: "正常在业",
		//经营品类
		categories: `塑料制品制造，塑料制品销售，市政设施管理，专用设备修理`,
		//公司地址
		companyAddress: "陕西省富平县庄里工业园",
		site: "陕西省富平县",
		//经营模式
		mode: "生产型企业",
		//注册资金
		capital: "10003万人民币",
		//成立日期
		establishment: "2011-11-28",
		//经营品牌
		brand: "晟翔；龙安",
		//主营产品
		mainProducts: "塑料制品制造，塑料制品销售，市政设施管理，专用设备修理",
		//企业名称
		headerTitle: "陕西晟翔管道科技有限公司",
		moreInfoName: "陕西晟翔管道科技有限公司",
		//供货区域
		supplyArea: "全国",
		//付款条件
		paymentTerms: `1.面议`,
		//工厂地址
		factoryAddress: "陕西省富平县庄里工业园",
		//工厂人数
		factoryHeadcount: "暂无信息",
		//产能
		capacity: "暂无信息",
		//年产值
		annualOutputValue: "暂无信息",

		// 生产规模
		// 生产基地总数
		// 生产基地总面积
		// 单个基地年产量
		factoryAddress: "省市布局1-2个",
		factoryHeadcount: "40000㎡",
		capacity: "--",

		//联系负责人
		person: "-- ",
		//联系电话
		contactNumber: "18191316399",
		//资质证书
		qualificationList: [
			{
				name: "环境管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz1.jpg",
			},
			{
				name: "陕西省国产涉及饮用水卫生安全产品卫生许可批件（PE管件-附件）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz2.jpg",
			},
			{
				name: "陕西省国产涉及饮用水卫生安全产品卫生许可批件（PE管件）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz3.jpg",
			},
			{
				name: "审核通知书-环境管理体系",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz4.jpg",
			},
			{
				name: "审核通知书-职业健康安全管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz5.jpg",
			},
			{
				name: "审核通知书-质量管理体系",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz6.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PE管材-附件）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz7.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PE管材）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz8.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PP-R管材-附件）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz9.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PP-R管材）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz10.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PP-R管件-附件）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz11.jpg",
			},
			{
				name: "渭南市国产涉及饮用水卫生安全产品卫生许可批件（PP-R管件",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz12.jpg",
			},
			{
				name: "营业执照",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz13.jpg",
			},
			{
				name: "职业健康安全管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz14.jpg",
			},
			{
				name: "质量管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz15.jpg",
			},
			{
				name: "中华人民共和国特种设备生产许可证",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxzz16.jpg",
			},
		],
		//荣誉证书
		certificateList: [
			{
				name: "富平县放心消费示范单位",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry1.jpg",
			},
			{
				name: "高新技术企业证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry2.jpg",
			},
			{
				name: "陕西省城镇供水排水协会会员单位",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry3.jpg",
			},
			{
				name: "陕西省塑料工业协会会员单位",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry4.jpg",
			},
			{
				name: "陕西省质量诚信重点推荐单位",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry5.jpg",
			},
			{
				name: "陕西省质量服务信誉AAA级单位",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry6.jpg",
			},
			{
				name: "陕西省重质量守信誉优秀企业",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry7.jpg",
			},
			{
				name: "商标注册证-反面",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry8.jpg",
			},
			{
				name: "商标注册证-正面",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry9.jpg",
			},
			{
				name: "知识产权管理体系认证证书",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry10.jpg",
			},
			{
				name: "专利10457472号-1（一种方便组合的给水管）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry11.jpg",
			},
			{
				name: "专利10457472号-2（一种方便组合的给水管）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry12.jpg",
			},
			{
				name: "专利10461905号-1（一种燃气管道对接固定装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry13.jpg",
			},
			{
				name: "专利10461905号-2（一种燃气管道对接固定装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry14.jpg",
			},
			{
				name: "专利10469339号-1（一种给水管定长截取装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry15.jpg",
			},
			{
				name: "专利10469339号-2（一种给水管定长截取装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry16.jpg",
			},
			{
				name: "专利10475138号-1（一种燃气管道用防碰撞装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry17.jpg",
			},
			{
				name: "专利10475138号-2（一种燃气管道用防碰撞装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry18.jpg",
			},
			{
				name: "专利10475568号-1（一种燃气管道用拦截装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry19.jpg",
			},
			{
				name: "专利10475568号-2（一种燃气管道用拦截装置）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry20.jpg",
			},
			{
				name: "专利10476551号-1（一种便于连接的给水管）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry21.jpg",
			},
			{
				name: "专利10476551号-2（一种便于连接的给水管）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry22.jpg",
			},
			{
				name: "专利10477202号-1（一种给水管铺设连接结构）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry23.jpg",
			},
			{
				name: "专利10477202号-2（一种给水管铺设连接结构）",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxry24.jpg",
			},
		],
		//合作伙伴
		cooperativeList: [
			{
				name: "陕西建工第四建设集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb1.png",
				desc: "",
			},
			{
				name: "陕西华山路桥集团有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb1.png",
				desc: "",
			},
			{
				name: "陕西建工第十建设集团责任有限公司 ",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb1.png",
				desc: "",
			},
			{
				name: "陕西省水务集团富平供水有限公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb2.png",
				desc: "",
			},
			{
				name: "白银市给排水公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb3.png",
				desc: "",
			},
			{
				name: "新绛县绛之泉城乡供水有限公司",
				path: "",
				desc: "",
			},
			{
				name: "陕西德恒立信建设工程有限公司蒲城分公司",
				path: "https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/sx/sxhb4.png",
				desc: "",
			},
		],
		//投标数据
		biddingList: [
			{
				name: "中标次数",
				numText: 0,
				num: 3,
				path: icon1,
				color: "#FFBC51",
			},
			{
				name: "履约次数",
				numText: 0,
				num: 3,
				path: icon2,
				color: "#F184A0",
			},
			{
				name: "履约金额",
				numText: "--",
				num: "--",
				path: icon3,
				color: "#AAABC1",
			},
		],
		//为您推荐其他家类似供应商列表
		recommendList: [],
	},
    listData: {
		productList: [
			{ name: "PE100给水管材", img: sxcp1 },
			{ name: "PE100给水管材", img: sxcp4 },
			{ name: "PE100燃气管材", img: sxcp5 },
			{ name: "PE100给水管材", img: sxcp8 },
			{ name: "PP-R冷热水管材", img: sxcp9 },
			{ name: "HDPE灌溉管", img: sxcp12 },
			{ name: "MPP电力电缆护套管", img: sxcp13 },
			{ name: "PE100给水管件", img: sxcp15 },
			{ name: "PE100给水电熔管件", img: sxcp18 },
			{ name: "PE100燃气管件", img: sxcp19 },
			{ name: "PP-R管件", img: sxcp22 },
		],
		navList: [
			{
				name: "管材",
				isShow: false,
				id: 1,
				children: ["PE100给水管材", "PE100给水管材", "PE100燃气管材", "PE100给水管材", "PP-R冷热水管材", "HDPE灌溉管"],
			},
			{
				name: "管件",
				isShow: false,
				id: 2,
				children: ["MPP电力电缆护套管", "PE100给水管件", "PE100给水电熔管件", "PE100燃气管件", "PP-R管件"],
			},
		],
	},
    productDetailsData:	{
		PE100给水管材: {
			name: "PE100给水管材",
			img: sxcp1,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp1,
				},
			],
			price: "--",
			detailImgs: [sxcp1, sxcp2, sxcp3],
			modelNumberText: "φ20-φ630直管（PN0.6、PN0.8、PN1.0、PN1.25、PN1.6、PN2.0)",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                                                 PE(聚乙烯）是乙烯经聚合制得的一种热塑性树脂，聚乙烯异味较小，手感似蜡，具有优良的耐低温性能，且化学稳定性好，能耐大多数酸碱的侵蚀。我公司生产的“晟翔”牌PE给水管材按国标GB/T13663.2-2018执行，管材颜色为蓝色或黑色带蓝条。目前已成为给排水系统的重要应用管道，在各地均广泛应用。                                                       二、产品详情   
1.PE管加工时不添加重金属盐稳定剂，材料无毒性，无结垢层，不滋生细菌，很好地解决了城市饮用水的二次污染。
2.PE管韧性好，耐冲击强度高，重物直接压过管道，不会导致管道破裂。
3.除少数强氧化剂外，可耐多种化学介质的侵蚀；无电化学腐蚀。
4.PE管热熔或电熔接口的强度高于管材本体，接缝不会由于土壤移动或活载荷的作用而断开。
5.在额定温度、压力状况下，PE管道可安全使用50年以上。
6.管道质轻，焊接工艺简单，施工方便，工程综合造价低。                    `,
			report: [sxbg1, sxbg2, sxbg3, sxbg4, sxbg5, sxbg6],
		},

		PE100给水管材: {
			name: "PE100给水管材",
			img: sxcp4,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp4,
				},
			],
			price: "--",
			detailImgs: [sxcp4],
			modelNumberText: "φ20-φ63盘管（PN1.0、PN1.25、PN1.6、PN2.0)",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                                                 PE(聚乙烯）是乙烯经聚合制得的一种热塑性树脂，聚乙烯异味较小，手感似蜡，具有优良的耐低温性能，且化学稳定性好，能耐大多数酸碱的侵蚀。我公司生产的“晟翔”牌PE给水管材按国标GB/T13663.2-2018执行，管材颜色为蓝色或黑色带蓝条。目前已成为给排水系统的重要应用管道，在各地均广泛应用。                                                       二、产品详情   
			1.PE管加工时不添加重金属盐稳定剂，材料无毒性，无结垢层，不滋生细菌，很好地解决了城市饮用水的二次污染。
			2.PE管韧性好，耐冲击强度高，重物直接压过管道，不会导致管道破裂。
			3.除少数强氧化剂外，可耐多种化学介质的侵蚀；无电化学腐蚀。
			4.PE管热熔或电熔接口的强度高于管材本体，接缝不会由于土壤移动或活载荷的作用而断开。
			5.在额定温度、压力状况下，PE管道可安全使用50年以上。
			6.管道质轻，焊接工艺简单，施工方便，工程综合造价低。                    `,
			report: [sxbg7, sxbg8, sxbg9, sxbg10, sxbg11, sxbg12],
		},

		PE100燃气管材: {
			name: "PE100燃气管材",
			img: sxcp5,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp5,
				},
			],
			price: "--",
			detailImgs: [sxcp5, sxcp6, sxcp7],
			modelNumberText: "φ20-φ630直管    (SDR11、SDR17、SDR21、SDR26)",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                                          PE(聚乙烯）是乙烯经聚合制得的一种热塑性树脂。我公司生产的“晟翔”牌PE燃气管材按国标GB15558.1-2015执行，PE燃气管材颜色为橙色或黑色，黑色管材上共挤出4条橙色条，一般用于城镇及乡村燃气工程。                                               二、产品详情                       
				1.柔韧:PE管的断裂延伸率为500%以上，在不同地沉和地震等地壳变动下，也不会破裂，具有高安全性。弯曲半径(R≥15D) ,不必使用弯管接头，便于施工。                                                        2.耐寒:PE管的线性膨胀系数为1.5×104mm /mm℃其长度几乎不受温度变化影响，即便在-80℃时也不发生物理性变化，尤其适合于严寒地区。                              3.PE管可用电熔或热熔方式连接，其连接部完整、紧密、绝对不会泄露。                                     4.耐腐蚀性:常温下浸入盐酸、硫酸（≤70%）、硝酸（≤25%）、磷酸、氢氟酸、铬酸（≤10%）等溶液中， PE管不受影响。在60℃下将PE管浸入多种碱液、无机盐及海水中， PE管不会发生腐蚀。常温下PE管可耐双氧水、甲汽油等有机溶剂， PE管不会发生腐蚀。                               5.运输、施工方便：PE管重量轻(只为钢管的1/7) 、柔软性好，φ20-63管可缠绕，便于运输、施工。                                       6.安全使用50年以上。 `,
			report: [sxbg13, sxbg14, sxbg15, sxbg16, sxbg17, sxbg18],
		},

		PE100给水管材: {
			name: "PE100给水管材",
			img: sxcp8,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp8,
				},
			],
			price: "--",
			detailImgs: [sxcp8],
			modelNumberText: "φ20-φ63盘管   (SDR11、SDR17)",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                                          PE(聚乙烯）是乙烯经聚合制得的一种热塑性树脂。我公司生产的“晟翔”牌PE燃气管材按国标GB15558.1-2015执行，PE燃气管材颜色为橙色或黑色，黑色管材上共挤出4条橙色条，一般用于城镇及乡村燃气工程。                                               二、产品详情                       
				1.柔韧:PE管的断裂延伸率为500%以上，在不同地沉和地震等地壳变动下，也不会破裂，具有高安全性。弯曲半径(R≥15D) ,不必使用弯管接头，便于施工。                                                        2.耐寒:PE管的线性膨胀系数为1.5×104mm /mm℃其长度几乎不受温度变化影响，即便在-80℃时也不发生物理性变化，尤其适合于严寒地区。                              3.PE管可用电熔或热熔方式连接，其连接部完整、紧密、绝对不会泄露。                                     4.耐腐蚀性:常温下浸入盐酸、硫酸（≤70%）、硝酸（≤25%）、磷酸、氢氟酸、铬酸（≤10%）等溶液中， PE管不受影响。在60℃下将PE管浸入多种碱液、无机盐及海水中， PE管不会发生腐蚀。常温下PE管可耐双氧水、甲汽油等有机溶剂， PE管不会发生腐蚀。                               5.运输、施工方便：PE管重量轻(只为钢管的1/7) 、柔软性好，φ20-63管可缠绕，便于运输、施工。                                       6.安全使用50年以上。 `,
			report: [sxbg19, sxbg20],
		},

		"PP-R冷热水管材": {
			name: "PP-R冷热水管材",
			img: sxcp9,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp9,
				},
			],
			price: "--",
			detailImgs: [sxcp9, sxcp10, sxcp11],
			modelNumberText: "φ20-φ110  (S5.0、S4.0、S3.2、S2.5)",
			brand: "晟翔",
			describe: `一、产品介绍                                                            PP-R管又称“聚丙烯管”，我公司生产的“晟翔”牌PP-R冷热水管材按国标GB/T18472.2-2017执行，管材颜色为：冷水管材白色蓝条，热水管材白色红。                                                             二、产品详情                                                   1.良好的柔软性：PP-R管材、管件不易受挤压而变形，即使变形也不破裂，并大大减少接头使用量。                                         2. 耐腐蚀、防水垢：PP-R管材的化学性质可以抵抗水中的化学元素侵蚀，同时平滑的内表面可以避免水垢的形成。                              3.耐高温、耐高：压PP-R管材、管件常温下承受水压力为45千克/平方厘米，热水管不变形温度为112℃。
			4. 寿命长：PP-R管材无老化，具有50年以上的寿命，几乎是半永久性的产品。                                                          5.施工简便快速：PP-R管材、管件的柔软性使得施工变得十分快捷，并容易连接（用热熔机承插连接），安全可靠。                            6.经济实惠：由于施工简单，不存在与其他工程间的矛盾及影响，缩短工期，具有优越的经济性。`,
			report: [sxbg21, sxbg22],
		},

		HDPE灌溉管: {
			name: "HDPE灌溉管",
			img: sxcp12,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp12,
				},
			],
			price: "--",
			detailImgs: [sxcp12],
			modelNumberText: "φ20-φ630（PN0.6、PN0.8、PN1.0、PN1.25、PN1.6、PN2.0)",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                          
			HDPE灌溉管是以PE树脂为主要原料，加入助剂，经挤出机挤出成型而成，农田灌溉HDPE管的耐压性能是其主要的力学指标，影响管材耐压性能的既有机械设备因素，也有原材料和配方因素,同时也要考虑工艺的相应调整，灌溉HDPE管材及管件经溶解实验证实不影响水质，，为目前高标准农田灌溉用的较佳管材之一。农业节水的出路在于发展节水灌溉，推广先进的灌溉技术和措施，管道输水灌溉就是节水的基本措施之一 。                              二、产品详情                                                    1.产品具有省水、节能、省地、省工、缩短 轮灌周期。                               2.受自然和人为破坏因素影响小。                                  3.便于管理，具有显著的经济效益。`,
			report: [],
		},

		MPP电力电缆护套管: {
			name: "MPP电力电缆护套管",
			img: sxcp13,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp13,
				},
			],
			price: "--",
			detailImgs: [sxcp13, sxcp14],
			modelNumberText: "DS100-DS250",
			brand: "晟翔",
			describe: `一、产品介绍                                                                                                                                  MPP电力管采用改性聚丙烯为主要原材料，施工时无须大量挖泥、挖土及破坏路面，广泛应用于道路、铁路、建筑物、河床下等特殊地段敷设管道、电缆等施工工程。同时，非开挖电力管工程可去除因传统施工所造成的尘土飞扬、交通阻塞等扰民因素，更适应当前的环保要求。晟翔MPP电力管具有抗高温、耐外压的特点，适用于10kV以上高压输电线电缆排管管材，已成为城市线网落地、电力电缆保护等的主要选择。                              二、产品详情                                                   1.施工时无需大量开挖，路面复原难度小。
			2.具有优良的电气绝缘性。
			3.具有较高的热变形温度和低温冲击性能。
			4.抗拉、抗压性能高。
			5.质轻、光滑、磨擦主力小、可热熔焊对接。
			6.应用场景广阔，可适应 -5～70℃的使用温度范围。`,
			report: [sxbg23, sxbg24],
		},

		PE100给水管件: {
			name: "PE100给水管件",
			img: sxcp15,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp15,
				},
			],
			price: "--",
			detailImgs: [sxcp15, sxcp16, sxcp17],
			modelNumberText: "φ20-φ630",
			brand: "晟翔",
			describe: `PE管件是一种新型的专利产品，作为一种新型材料它之所以受到人们的青睐是因为有着以下优点：
			　　1. PE管件的内部有紧锁箍、阶梯型环形密封圈这些部件，科学的设计保证了PE管件的牢固性和密封性。这使得它比其他管件更具优势。
			　　2.PE管件独特的性质决定了它安装起来更加容易，联接也方便，灵活性十分强，损坏的时候可以很简单的进行更换。
			　　3.外形美观。PE管件外表不像传统管件那样，它具有很好的美观性。
			　　4.PE管件除了用来连接PE管道外，还可以连接U-PVC、钢管，这也是其实用性强的一个体现。
			　　5.规格种类齐全。PE管件发展至今，它的种类和规格已经十分多样，能满足各种需求，如直通、异径直通、变径三通、丝口接头等各种类型，尺寸规格，能满足不同环境。`,
			report: [sxbg25, sxbg26],
		},

		PE100给水电熔管件: {
			name: "PE100给水电熔管件",
			img: sxcp18,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp18,
				},
			],
			price: "--",
			detailImgs: [sxcp18],
			modelNumberText: "φ20-φ630",
			brand: "龙安",
			describe: `电熔管件在给水管道工程和维修中有它重要、不可替代的作用，特别是在施工中电熔管件受外界环境和人为因素的影响较小，因此可靠性更好，更受用户欢迎。工程中越来越多地使用电熔管件。由于电熔管件的基体为PE材料，因此，与PE管组成的PE管道系统一起解决了传统管道的两大难题：腐蚀和接头处泄漏。其优点主要体现如下：                                              (1)耐腐蚀：使用寿命长。                                        (2)接头处不泄漏：采用电熔管件连接，本质上保证PE管道系统的接口材质、结构与管体本身的同一性，实现了接头与管材的一体化。                (3)可对地下运动和端载荷进行有效抵抗。`,
			report: [],
		},

		PE100燃气管件: {
			name: "PE100燃气管件",
			img: sxcp19,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp19,
				},
			],
			price: "--",
			detailImgs: [sxcp19, sxcp20, sxcp21],
			modelNumberText: "φ20-φ630",
			brand: "宇华",
			describe: `燃气聚乙烯管道系统的管件主要分为热熔管件和电熔管件两种，由于价格的原因在工程应用中热熔管件的用量比电熔管件多，价格相对便宜，但是电熔管件在工程和维修中有它重要、不可替代的作用，特别是在施工中电熔管件受外界环境和人为因素的影响较小，因此可靠性更好，更受用户欢迎。尤其在燃气管工程中正越来越多地使用电熔管件。同时由于电熔管件生产技术复杂、成本高、销售价也较高，同时由于电熔管件的基体为PE材料，因此，与PE管组成的PE管道系统一起解决了传统管道的两大难题：腐蚀和接头处泄漏。其优点主要体现如下：                                        (1)耐腐蚀：使用寿命长。                                        (2)接头处不泄漏：采用电熔管件连接，本质上保证PE管道系统的接口材质、结构与管体本身的同一性，实现了接头与管材的一体化。                       (3)可对地下运动和端载荷进行有效抵抗。`,
			report: [sxbg27, sxbg28, sxbg29, sxbg30, sxbg31, sxbg32, sxbg33],
		},

		"PP-R管件": {
			name: "PP-R管件",
			img: sxcp22,
			modelNumber: [
				{
					title: "暂无",
					img: sxcp22,
				},
			],
			price: "--",
			detailImgs: [sxcp22],
			modelNumberText: "φ20-φ110",
			brand: "晟翔",
			describe: `PPR管件管除了具有一般塑料管重量轻、耐腐蚀、不结垢、使用寿命长等特点外，还具有以下主要特点：                                        1、无毒、卫生。                                                 2、热水管热水保温节能。                                               3、耐热性好。                                                   4、使用寿命长。                                                             5、安装方便。                                                   6、物料可回收利用。	`,
			report: [],
		},
	},
    contactListData: {
		list: [
			{
				name: "--",
				position: "--",
				id: "3",
				phoneNum: "--",
				telephone: "18191316399",
				color: "#219b94",
				email: "2814419581@qq.com",
			},
			{
				name: "--",
				position: "--",
				id: "2",
				phoneNum: "13772726797",
				telephone: "--",
				color: "#007DFF ",
				email: "--",
			},
		],
	},
    caseData: {
		list: [
			{
				name: "庄里工业园区富安二路市政工",
				id: 1,
				price: "82254.79元",
				time: "2016",
				site: "陕西省渭南市",
				type: "交通运输枢纽及仓储物流",
				unit: "陕西建工第四建设集团有限公司",
				desc: "项目位于陕西省渭南市富平县庄里镇工业园区，由陕西建工第四建设集团有限公司承建，对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方好评。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg1 }],
				// 合作证明图
				contractList: [
					{ title: "", path: sxht1 },
					{ title: "", path: sxht2 },
				],
				product: "PE管材",
			},

			{
				name: "富平县庄里镇东北环路及南环线市政道路工程第五标段",
				id: 2,
				price: "42500.00元",
				time: "2017",
				site: "陕西省渭南市",
				type: "交通运输枢纽及仓储物流",
				unit: "陕西华山路桥集团有限公司",
				desc: "项目位于陕西省渭南市富平县庄里镇，由陕西华山路桥集团有限公司承建，对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方的高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg2 }],
				// 合作证明图
				contractList: [
					{ title: "", path: sxht3 },
					{ title: "", path: sxht4 },
				],
				product: "PE管材",
			},

			{
				name: "宝鸡市渭河川道城乡供水岐山县安乐社区应急工程",
				id: 3,
				price: "3134357.72元",
				time: "2019",
				site: "陕西省宝鸡市",
				type: "基础建设",
				unit: "陕西华山路桥集团有限公司",
				desc: "项目位于陕西省宝鸡市岐山县，甲方对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg3 }],
				// 合作证明图
				contractList: [{ title: "", path: sxht5 }],
				product: "PE给水管材及管件",
			},

			{
				name: "富平县淡村镇供水工程管网续建提升项目",
				id: 4,
				price: "3272280.99元",
				time: "2018",
				site: "陕西省渭南市",
				type: "基础建设",
				unit: "陕西省水务集团富平供水有限公司",
				desc: "项目位于陕西省渭南市富平县淡村镇，由陕西省水务集团富平供水有限公司承建，对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方的高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg4 }],
				// 合作证明图
				contractList: [{ title: "", path: sxht6 }],
				product: "PE给水管材",
			},

			{
				name: "白银市城区给水管道入廊工程设备、材料采购项目",
				id: 5,
				price: "1756889.62元",
				time: "2021",
				site: "甘肃省白银市",
				type: "基础建设",
				unit: "白银市给排水公司",
				desc: "项目位于甘肃省白银市，项目业主为白银市给排水公司，对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方的高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg5 }],
				// 合作证明图
				contractList: [{ title: "", path: sxht7 }],
				product: "PE给水管材及管件",
			},

			{
				name: "新绛县县城供水工程建设项目",
				id: 6,
				price: "1597788.65元",
				time: "2021",
				site: "陕西省运城市",
				type: "基础建设",
				unit: "新绛县绛之泉城乡供水有限公司",
				desc: "项目位于陕西省运城市，项目业主为新绛县绛之泉城乡供水有限公司，对产品质量要求非常高。选择了我们“晟翔”牌管材，此项目合作愉快，得到甲方的好评。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg6 }],
				// 合作证明图
				contractList: [{ title: "", path: sxht8 }],
				product: "PE给水管材及管件",
			},

			{
				name: "蒲城县尧山镇-桥陵镇-兴镇中压燃气管道工程",
				id: 7,
				price: "2956500.00元",
				time: "2023",
				site: "陕西省渭南市",
				type: "石油及天然气",
				unit: "陕西德恒立信建设工程有限公司蒲城分公司",
				desc: "项目位于陕西省渭南市，由陕西德恒立信建设工程有限公司蒲城分公司主导施工，对产品质量要求非常高。选择了我们“晟翔”牌管材，长期合同客户，现项目进行中，产品得到需方高度认可。",
				//现场图片
				imgList: [],
				//轮播图
				proImgList: [{ title: "", path: sxcg7 }],
				// 合作证明图
				contractList: [
					{ title: "", path: sxht9 },
					{ title: "", path: sxht10 },
				],
				product: "PE燃气管材",
			},
		],
	},
    evaluationData:{
		//企业诚信
		goodFaithList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "企业失信",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "法律诉讼",
				isShow: true,
				number: 2,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "行政处罚",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "严重违纪",
				isShow: false,
				number: 0,
			},
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${1}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${1}.png`,
				title: "经营异常",
				isShow: false,
				number: 0,
			},
		],
		//实力徽章
		badgeList: [
			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${7}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${7}.png`,
				// title: '百强地产合作',
				subtitle: "发明专利",
				isShow: true,
			},

			{
				hit: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge${8}.png`,
				grey: `https://gcj-statics.oss-cn-beijing.aliyuncs.com/fe-mall/image/evaluation/badge-bg${8}.png`,
				title: "AAA",
				subtitle: "级信用企业",
				isShow: true,
			},
		],
	},
    successfulBidderData: {
		info: [
			{
				name1: "礼县盐官镇小城镇建设集中供水工程（第七标段）",
				name2: "礼县盐官镇小城镇建设集中供水工程（第七标段）",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "新绛县县城供水工程建设项目(6标段)",
				name2: "新绛县县城供水工程建设项目(6标段)",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "太谷国新城市燃气有限公司2019-2020年度城市（农村）燃气管网及入户工程设备、材料采购",
				name2: "太谷国新城市燃气有限公司2019-2020年度城市（农村）燃气管网及入户工程设备、材料采购项目",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "中央统筹土地出让收益农田水利建设工程管材采购",
				name2: "中央统筹土地出让收益农田水利建设工程管材采购",
				name3: "物资采购",
				date: "--",
			},
			{
				name1: "广场项目PE管道采购",
				name2: "广场项目PE管道采购",
				name3: "物资采购",
				date: "--",
			},
			{
				"企业名称": "陕西晟翔管道科技有限公司",
				"name1": "庄里工业园区富安二路市政工程",
				"name4": "陕西华山路桥集团有限公司",
				"name2": "庄里工业园区富安二路市政工程",
				"name3": "物资采购",
				"date": "2016年6月28日",
				"out": true
			},
			{
				"企业名称": "陕西晟翔管道科技有限公司",
				"name1": "富平县庄里镇东北环路及南环线市政道路工程第五标段",
				"name4": "陕西建工第十建设集团责任有限公司 ",
				"name2": "富平县庄里镇东北环路及南环线市政道路工程第五标段",
				"name3": "物资采购",
				"date": "2017年8月5日",
				"out": true
			},
			{
				"企业名称": "陕西晟翔管道科技有限公司",
				"name1": "宝鸡市渭河川道城乡供水岐山县安乐社区应急工程",
				"name4": "陕西省水务集团富平供水有限公司",
				"name2": "宝鸡市渭河川道城乡供水岐山县安乐社区应急工程",
				"name3": "物资采购",
				"date": "2018年11月1日",
				"out": true
			}
		],
	},
    lawData: {
		info: [
			{
				caseName: "陕西晟翔管道科技有限公司、翼城县晋能燃气有限公司等买卖合同纠纷执行异议执行裁定书",
				reference: "（2022）陕0528执异29号",
				cause: "买卖合同纠纷",
				identity: "申请执行人",
				caseType: "执行案件",
				date: "2022-09-30",
			},
			{
				caseName: "陕西晟翔管道科技有限公司与旬阳县江南天然气有限公司买卖合同纠纷结案通知书",
				reference: "（2021）陕0528执550号",
				cause: "买卖合同纠纷",
				identity: "申请执行人",
				caseType: "执行案件",
				date: "2021-06-23",
			},
		],
	},
    tipData:{
		info: [
			{
				title: "陕建云采会员",
			},
			{
				title: "成立10年以上",
			},
			{
				title: "高新技术企业",
			},
		],
	},
}